import { ListContact, ListContactsRequest } from '../../types/ListContact';
import { CreateListRequest, ListItem } from '../../types/Lists';
import { defaultList } from '../../utils/defaultList';
import { libApiInstance } from '../axios';

// Api call to request the list of groups
export async function requestGroupsList(signal?: AbortSignal): Promise<ListItem[]> {
    const result = await libApiInstance.get('/contacts/lists', { signal });

    return [defaultList, ...result.data];
}

// Api call to request the list of contacts in a group
export async function requestGroupContacts(
    listDataReq: ListContactsRequest,
    signal?: AbortSignal,
): Promise<ListContact[]> {
    const result = await libApiInstance.post('/contacts/lists/names', listDataReq, { signal });

    return result.data;
}

// Api call to create a new group list
export async function requestCreateGroupList(data: CreateListRequest): Promise<number> {
    const result = await libApiInstance.post('/contacts/lists', data);

    return result.data;
}

export async function requestDeleteGroupList(listId: number): Promise<number> {
    const result = await libApiInstance.delete(`/contacts/lists/${listId}`);

    return result.data;
}
